import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemePlanSpotTeklifler_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemePlanSpotTeklifler_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Get_Tanim_SpotTedarikciListe: any[];
  Get_Tanim_SpotTedarikciListe_dummy: any[];
  YuklemePlan_Get_MasterById: any[];
  YuklemePlan_Get_MasterById_dummy: any[];
  YuklemePlanv2_SpotTeklifListesi: any[];
  YuklemePlanv2_SpotTeklifListesi_dummy: any[];
  Get_Firma_ParametreByName_TedarikciAtamaMail: any[];
  Get_Firma_ParametreByName_TedarikciAtamaMail_dummy: any[];
  Get_Firma_ParametreByName_SpotAktarimMail: any[];
  Get_Firma_ParametreByName_SpotAktarimMail_dummy: any[];
  GetMultiSelectValues: any[];
  GetMultiSelectValues_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  Concatenate_AnaTedarikciMailBody: string;
  Concatenate_AnaTedarikciMailBody_dummy: string;
  SendMail: boolean;
  SendMail_dummy: boolean;
  YuklemePlanv2_SpotAktarBaslat: number;
  YuklemePlanv2_SpotAktarBaslat_dummy: number;
  YuklemePlanv2_SpotTalepKaydet: number;
  YuklemePlanv2_SpotTalepKaydet_dummy: number;
  Get_Tanim_MusteriTedarikci_ById: any[];
  Get_Tanim_MusteriTedarikci_ById_dummy: any[];
  GetMailBody_SpotTedarikciTeklifTalepBildirim: string;
  GetMailBody_SpotTedarikciTeklifTalepBildirim_dummy: string;
  ForEach3: Kuika.ThirdPartyApisCollection.IDS;
  ForEach3_dummy: Kuika.ThirdPartyApisCollection.IDS;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  Confirmation: boolean;
  Confirmation_dummy: boolean;
  YuklemePlanv2_SpotTeklifOnayla: number;
  YuklemePlanv2_SpotTeklifOnayla_dummy: number;
  GetMailBody_TedarikciAtamaBildirim: string;
  GetMailBody_TedarikciAtamaBildirim_dummy: string;
  Get_SpotTeklif_RedMailListe: any[];
  Get_SpotTeklif_RedMailListe_dummy: any[];
  GetMailBody_SpotTedarikciTeklifRedBildirim: string;
  GetMailBody_SpotTedarikciTeklifRedBildirim_dummy: string;
  ForEach4: Get_SpotTeklif_RedMailListe;
  ForEach4_dummy: Get_SpotTeklif_RedMailListe;
  GetMailBody_SpotTedarikciTeklifOnay: string;
  GetMailBody_SpotTedarikciTeklifOnay_dummy: string;
  GoBack: any;
  GoBack_dummy: any;
  isComp971265Visible: "visible" | "hidden";
  isComp586230Enabled: "enabled" | "disabled";
  isComp241317Enabled: "enabled" | "disabled";
  isComp391931Enabled: "enabled" | "disabled";
  isComp44544Enabled: "enabled" | "disabled";
  isComp579048Enabled: "enabled" | "disabled";
  isComp108008Enabled: "enabled" | "disabled";
}

export class YuklemePlanSpotTeklifler_ScreenBase extends React.PureComponent<
  IYuklemePlanSpotTeklifler_ScreenProps,
  any
> {
  yuklemeplanspotteklifler_241317_value_kuikaDateRef: React.RefObject<any>;
  yuklemeplanspotteklifler_624706_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f5bca1c-d1bb-411f-b4ce-9aed61ed738a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 380143,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        {
          Id: 822755,
          PropertyName: "value",
          Value: "Spot Tedarikçi Teklif Talepleri",
        },
        { Id: 905738, PropertyName: "value", Value: "Yükleme No" },
        { Id: 94683, PropertyName: "value", Value: "Araç Tipi" },
        { Id: 586230, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 71255, PropertyName: "value", Value: "Planlanan Yükleme Tarihi" },
        { Id: 241317, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 983313, PropertyName: "value", Value: "Palet Sayisi" },
        { Id: 391931, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 641820, PropertyName: "value", Value: "Tonaj" },
        { Id: 44544, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 404281, PropertyName: "value", Value: "Varış İl" },
        { Id: 579048, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 571799, PropertyName: "value", Value: "Varış İlçe" },
        { Id: 108008, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 629625, PropertyName: "value", Value: "Tedarikçi Seçiniz" },
        { Id: 909757, PropertyName: "placeholder", Value: "Choose..." },
        { Id: 723285, PropertyName: "label", Value: "Teklif İste" },
        {
          Id: 624706,
          PropertyName: "nodatafoundmessage",
          Value: "Kayıt bulunamadı",
        },
        { Id: 197208, PropertyName: "title", Value: "İşlemler" },
        { Id: 677350, PropertyName: "title", Value: "Tedarikçi " },
        { Id: 64072, PropertyName: "value", Value: "[datafield:firmaadi]" },
        { Id: 399769, PropertyName: "title", Value: "Teklif Tutarı" },
        { Id: 99954, PropertyName: "value", Value: "[datafield:tekliftutari]" },
        { Id: 259526, PropertyName: "title", Value: "Tahmini Varış Tarihi" },
        {
          Id: 658014,
          PropertyName: "value",
          Value: "[datafield:tahminivaris]",
        },
        { Id: 696981, PropertyName: "title", Value: "Açıklama" },
        { Id: 785740, PropertyName: "value", Value: "[datafield:aciklama]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  ForEach4: any[];

  constructor(props) {
    super(props);
    this.yuklemeplanspotteklifler_586230_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanspotteklifler_241317_value_kuikaDateRef = React.createRef();
    this.yuklemeplanspotteklifler_391931_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanspotteklifler_44544_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanspotteklifler_579048_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanspotteklifler_108008_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanspotteklifler_624706_value_kuikaTableRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      Get_Tanim_SpotTedarikciListe: [],
      YuklemePlan_Get_MasterById: [],
      YuklemePlanv2_SpotTeklifListesi: [],
      Get_Firma_ParametreByName_TedarikciAtamaMail: [],
      Get_Firma_ParametreByName_SpotAktarimMail: [],
      GetMultiSelectValues: [],
      IfThenElse: false,
      Confirmation: false,
      YuklemePlanv2_SpotTeklifOnayla: 0,
      Get_Tanim_MusteriTedarikci_ById: [],
      GetMailBody_TedarikciAtamaBildirim: "",
      SendMail: false,
      Get_SpotTeklif_RedMailListe: [],
      ForEach: false,
      GetMailBody_SpotTedarikciTeklifOnay: "",
      Notify: false,
      GoBack: "",
      isComp971265Visible: "hidden",
      isComp586230Enabled: "disabled",
      isComp241317Enabled: "disabled",
      isComp391931Enabled: "disabled",
      isComp44544Enabled: "disabled",
      isComp579048Enabled: "disabled",
      isComp108008Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanspotteklifler", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemePlanSpotTekliflerPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanspotteklifler", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanspotteklifler", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemePlanSpotTekliflerPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yuklemeplanspotteklifler_586230_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.aracTipi ?? undefined,
      yuklemeplanspotteklifler_241317_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)
          ?.planlananYuklemeTarihi ?? undefined,
      yuklemeplanspotteklifler_391931_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.paletSayisi ??
        undefined,
      yuklemeplanspotteklifler_44544_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.brutAgirlilk ??
        undefined,
      yuklemeplanspotteklifler_579048_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.varisIl ?? undefined,
      yuklemeplanspotteklifler_108008_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.varisIlce ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemePlanSpotTekliflerPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemePlanSpotTekliflerPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      UserRole_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
      BagliFirmaId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      YuklemeId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      FirmaNo_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      ParametreAdi_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "TedarikciAtamaMailTo",
          "string"
        ),
        "string"
      ),
      FirmaNo_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      ParametreAdi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("SpotAktarimMailTo", "string"),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.Get_Tanim_SpotTedarikciListe =
      result?.data.get_Tanim_SpotTedarikciListe;

    formVars.yuklemeplanspotteklifler_909757_options =
      stateVars.Get_Tanim_SpotTedarikciListe;
    stateVars.YuklemePlan_Get_MasterById =
      result?.data.yuklemePlan_Get_MasterById;
    formVars.yuklemeplanspotteklifler_586230_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
          : null
      );
    formVars.yuklemeplanspotteklifler_241317_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
        : null
    );
    formVars.yuklemeplanspotteklifler_391931_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].paletSayisi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].paletSayisi
          : null
      );
    formVars.yuklemeplanspotteklifler_44544_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].brutAgirlilk
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].brutAgirlilk
          : null
      );
    formVars.yuklemeplanspotteklifler_579048_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].varisIl
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].varisIl
          : null
      );
    formVars.yuklemeplanspotteklifler_108008_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].varisIlce
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].varisIlce
          : null
      );
    stateVars.YuklemePlanv2_SpotTeklifListesi =
      result?.data.yuklemePlanv2_SpotTeklifListesi;

    stateVars.Get_Firma_ParametreByName_TedarikciAtamaMail =
      result?.data.get_Firma_ParametreByName_TedarikciAtamaMail;
    stateVars.Get_Firma_ParametreByName_SpotAktarimMail =
      result?.data.get_Firma_ParametreByName_SpotAktarimMail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemePlanSpotTekliflerPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemeplanspotteklifler_586230_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
          : null
      );

    formVars.yuklemeplanspotteklifler_241317_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
        : null
    );

    formVars.yuklemeplanspotteklifler_391931_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].paletSayisi
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].paletSayisi
          : null
      );

    formVars.yuklemeplanspotteklifler_44544_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].brutAgirlilk
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].brutAgirlilk
          : null
      );

    formVars.yuklemeplanspotteklifler_579048_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].varisIl
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].varisIl
          : null
      );

    formVars.yuklemeplanspotteklifler_108008_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.YuklemePlan_Get_MasterById !== undefined
          ? stateVars.YuklemePlan_Get_MasterById?.length > 0
            ? stateVars.YuklemePlan_Get_MasterById[0].varisIlce
            : null
          : this.state.YuklemePlan_Get_MasterById?.length > 0
          ? this.state.YuklemePlan_Get_MasterById[0].varisIlce
          : null
      );

    stateVars.dataSource_909757 =
      stateVars.Get_Tanim_SpotTedarikciListe ??
      this.state.Get_Tanim_SpotTedarikciListe;
    stateVars.dataSource_909757 =
      stateVars.Get_Tanim_SpotTedarikciListe ??
      this.state.Get_Tanim_SpotTedarikciListe;

    stateVars.dataSource_624706 =
      stateVars.YuklemePlanv2_SpotTeklifListesi ??
      this.state.YuklemePlanv2_SpotTeklifListesi;
    stateVars.isComp971265Visible =
      ReactSystemFunctions.isGreaterThan(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanspotteklifler_624706_value",
          "teklifTutari"
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemePlanSpotTekliflerComponent_329984_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemePlanSpotTekliflerComponent_329984_onClick1_,
        "YuklemePlanSpotTeklifler",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "53291",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_329984_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_329984_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "YuklemePlanSpotTeklifler",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "869050",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YuklemePlanSpotTekliflerComponent_723285_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      parameter1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanspotteklifler_909757_value",
            "value",
            "Get_Tanim_SpotTedarikciListe",
            "id",
            "id"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_723285_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMultiSelectValues = result?.data.getMultiSelectValues;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanSpotTekliflerComponent_723285_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_723285_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "123fd046_730c_bfd8_2521_1146f7006738_notify",
        this.defaultML,
        "EN AZ 1 TEDARİKÇİ SEÇMELİSİNİZ !"
      ),
      ReactSystemFunctions.convertToTypeByName("danger", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YuklemePlanSpotTekliflerComponent_723285_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Value1_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeNo ?? this.props.screenInputs.yuklemeno,
        "string"
      ),
      Value2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "&nbsp;numaralı yükleme planı Geç Tedarik durumuna düştüğü için spot tedarikçi havuzuna aktarılmıştır.",
          "string"
        ),
        "string"
      ),
      templateId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirmaEPosta
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirmaEPosta
            : null
        ),
        "string"
      ),
      subject_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Gecikme Yaşanan Yükleme Emri Spot Tedarikçi Havuzuna Aktarılmıştır",
          "string"
        ),
        "string"
      ),
      sender_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      cc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Firma_ParametreByName_SpotAktarimMail !== undefined
            ? stateVars.Get_Firma_ParametreByName_SpotAktarimMail?.length > 0
              ? stateVars.Get_Firma_ParametreByName_SpotAktarimMail[0]
                  .parametreDegeri
              : null
            : this.state.Get_Firma_ParametreByName_SpotAktarimMail?.length > 0
            ? this.state.Get_Firma_ParametreByName_SpotAktarimMail[0]
                .parametreDegeri
            : null
        ),
        "string"
      ),
      bcc_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      fileAttachments_1: ReactSystemFunctions.convertToTypeByName(``, "string"),
      language_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      body_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Concatenate_AnaTedarikciMailBody
        ),
        "string"
      ),
      YuklemeId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TasiyiciId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].tasiyiciFirma
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].tasiyiciFirma
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_723285_onClick_else1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Concatenate_AnaTedarikciMailBody =
      result?.data.concatenate_AnaTedarikciMailBody;
    stateVars.SendMail = result?.data.sendMail;
    stateVars.YuklemePlanv2_SpotAktarBaslat =
      result?.data.yuklemePlanv2_SpotAktarBaslat;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanSpotTekliflerComponent_723285_onClick_else11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_723285_onClick_else1each1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      KullaniciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      TedarikciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.ForEach3?.selectedIds),
        "Guid"
      ),
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.ForEach3?.selectedIds),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_723285_onClick_else1each1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlanv2_SpotTalepKaydet =
      result?.data.yuklemePlanv2_SpotTalepKaydet;
    stateVars.Get_Tanim_MusteriTedarikci_ById =
      result?.data.get_Tanim_MusteriTedarikci_ById;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanSpotTekliflerComponent_723285_onClick_else1each11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_723285_onClick_else1each11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.Get_Tanim_MusteriTedarikci_ById !== undefined
          ? stateVars.Get_Tanim_MusteriTedarikci_ById?.length > 0
            ? stateVars.Get_Tanim_MusteriTedarikci_ById[0].firmaAdi
            : null
          : this.state.Get_Tanim_MusteriTedarikci_ById?.length > 0
          ? this.state.Get_Tanim_MusteriTedarikci_ById[0].firmaAdi
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanSpotTekliflerComponent_723285_onClick_else1each12_();
        resolve();
      });
    });
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_723285_onClick_else1each12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeNo ?? this.props.screenInputs.yuklemeno,
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      TedarikciAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Tanim_MusteriTedarikci_ById !== undefined
            ? stateVars.Get_Tanim_MusteriTedarikci_ById?.length > 0
              ? stateVars.Get_Tanim_MusteriTedarikci_ById[0].firmaAdi
              : null
            : this.state.Get_Tanim_MusteriTedarikci_ById?.length > 0
            ? this.state.Get_Tanim_MusteriTedarikci_ById[0].firmaAdi
            : null
        ),
        "string"
      ),
      templateId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Tanim_MusteriTedarikci_ById !== undefined
            ? stateVars.Get_Tanim_MusteriTedarikci_ById?.length > 0
              ? stateVars.Get_Tanim_MusteriTedarikci_ById[0].ePosta
              : null
            : this.state.Get_Tanim_MusteriTedarikci_ById?.length > 0
            ? this.state.Get_Tanim_MusteriTedarikci_ById[0].ePosta
            : null
        ),
        "string"
      ),
      subject_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Teklif Talebi Oluşturuldu",
          "string"
        ),
        "string"
      ),
      sender_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      cc_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      fileAttachments_1: ReactSystemFunctions.convertToTypeByName(``, "string"),
      language_1: ReactSystemFunctions.convertToTypeByName("", "string"),
      body_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMailBody_SpotTedarikciTeklifTalepBildirim
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_723285_onClick_else1each12_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMailBody_SpotTedarikciTeklifTalepBildirim =
      result?.data.getMailBody_SpotTedarikciTeklifTalepBildirim;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  YuklemePlanSpotTekliflerComponent_723285_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (
      ReactSystemFunctions.value(this, this.state.GetMultiSelectValues)?.length
    ) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.GetMultiSelectValues
      )) {
        this.ForEach3 = item;
        await this.YuklemePlanSpotTekliflerComponent_723285_onClick_else1each1();
      }
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "cc0340f2_33d1_8626_6433_40c5029feff3_notify",
        this.defaultML,
        "Yukleme Planı seçilen tedarikçilere aktarıldı. Gelen Teklifleri kontrol ediniz"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YuklemePlanSpotTekliflerComponent_723285_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanspotteklifler_909757_value",
            "value",
            "Get_Tanim_SpotTedarikciListe",
            "id",
            "id"
          )
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.YuklemePlanSpotTekliflerComponent_723285_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.YuklemePlanSpotTekliflerComponent_723285_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemePlanSpotTekliflerComponent_971265_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Confirmation = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "135fcc66_fd31_ed5c_8502_0e61d6eb7a53_confirmation_action",
        this.defaultML,
        ReactSystemFunctions.convertToTypeByName(
          "Teklif kabul edilerek, diğer teklifler red durumuna getitirlecektir. Emin misiniz ?",
          "string"
        )
      ),
      ReactSystemFunctions.convertToTypeByName("Poppins", "string"),
      ReactSystemFunctions.convertToTypeByName("TEKLİF ONAYLANIYOR", "string"),
      ReactSystemFunctions.convertToTypeByName("question", "string"),
      ReactSystemFunctions.convertToTypeByName("#ff3a24", "string")
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanSpotTekliflerComponent_971265_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanspotteklifler_624706_value",
          "id"
        ),
        "Guid"
      ),
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      TedarikciId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanspotteklifler_624706_value",
          "tedarikciId"
        ),
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Confirmation),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_971265_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.YuklemePlanv2_SpotTeklifOnayla =
        result?.data.yuklemePlanv2_SpotTeklifOnayla;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanspotteklifler_624706_value",
          "tedarikciId"
        ),
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Confirmation),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_971265_onClick2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Tanim_MusteriTedarikci_ById =
        result?.data.get_Tanim_MusteriTedarikci_ById;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      IsSayisi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      YuklemeEmirListesi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeNo ?? this.props.screenInputs.yuklemeno,
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Confirmation),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_971265_onClick3_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetMailBody_TedarikciAtamaBildirim =
        result?.data.getMailBody_TedarikciAtamaBildirim;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick4_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      templateId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Tanim_MusteriTedarikci_ById !== undefined
            ? stateVars.Get_Tanim_MusteriTedarikci_ById?.length > 0
              ? stateVars.Get_Tanim_MusteriTedarikci_ById[0].ePosta
              : null
            : this.state.Get_Tanim_MusteriTedarikci_ById?.length > 0
            ? this.state.Get_Tanim_MusteriTedarikci_ById[0].ePosta
            : null
        ),
        "string"
      ),
      subject_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Yeni Yükleme Plan Atama Bildirimi",
          "string"
        ),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.GetMailBody_TedarikciAtamaBildirim
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Confirmation),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_971265_onClick4_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SendMail = result?.data.sendMail;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick5_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Confirmation),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_971265_onClick5_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_SpotTeklif_RedMailListe =
        result?.data.get_SpotTeklif_RedMailListe;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick6_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick_foreach6 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeNo ?? this.props.screenInputs.yuklemeno,
        "string"
      ),
      FirmaAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaAdi
            : null
        ),
        "string"
      ),
      TedarikciAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.firmaAdi),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_971265_onClick_foreach6",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetMailBody_SpotTedarikciTeklifRedBildirim =
      result?.data.getMailBody_SpotTedarikciTeklifRedBildirim;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanSpotTekliflerComponent_971265_onClick_foreach61_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick_foreach61_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      templateId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach4?.ePosta),
        "string"
      ),
      subject_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Teklif Red Bildirimi",
          "string"
        ),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      cc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Firma_ParametreByName_SpotAktarimMail !== undefined
            ? stateVars.Get_Firma_ParametreByName_SpotAktarimMail?.length > 0
              ? stateVars.Get_Firma_ParametreByName_SpotAktarimMail[0]
                  .parametreDegeri
              : null
            : this.state.Get_Firma_ParametreByName_SpotAktarimMail?.length > 0
            ? this.state.Get_Firma_ParametreByName_SpotAktarimMail[0]
                .parametreDegeri
            : null
        ),
        "string"
      ),
      bcc_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      fileAttachments_0: ReactSystemFunctions.convertToTypeByName(``, "string"),
      language_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      body_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.GetMailBody_SpotTedarikciTeklifRedBildirim
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(this, this.ForEach4?.ePosta),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_971265_onClick_foreach61_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SendMail = result?.data.sendMail;
      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  YuklemePlanSpotTekliflerComponent_971265_onClick6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (
      ReactSystemFunctions.value(this, this.state.Get_SpotTeklif_RedMailListe)
        ?.length
    ) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.Get_SpotTeklif_RedMailListe
      )) {
        this.ForEach4 = item;
        await this.YuklemePlanSpotTekliflerComponent_971265_onClick_foreach6();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanSpotTekliflerComponent_971265_onClick7_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      YuklemeNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeNo ?? this.props.screenInputs.yuklemeno,
        "string"
      ),
      TedarikciAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanspotteklifler_624706_value",
          "firmaAdi"
        ),
        "string"
      ),
      TeklifTutari_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanspotteklifler_624706_value",
          "teklifTutari"
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Confirmation),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_971265_onClick7_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetMailBody_SpotTedarikciTeklifOnay =
        result?.data.getMailBody_SpotTedarikciTeklifOnay;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick8_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      templateId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Firma_ParametreByName_SpotAktarimMail !== undefined
            ? stateVars.Get_Firma_ParametreByName_SpotAktarimMail?.length > 0
              ? stateVars.Get_Firma_ParametreByName_SpotAktarimMail[0]
                  .parametreDegeri
              : null
            : this.state.Get_Firma_ParametreByName_SpotAktarimMail?.length > 0
            ? this.state.Get_Firma_ParametreByName_SpotAktarimMail[0]
                .parametreDegeri
            : null
        ),
        "string"
      ),
      subject_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("SPOT TEKLIF ONAYI", "string"),
        "string"
      ),
      sender_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.GetMailBody_SpotTedarikciTeklifOnay
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Confirmation),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YuklemePlanSpotTeklifler/YuklemePlanSpotTekliflerComponent_971265_onClick8_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SendMail = result?.data.sendMail;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick9_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.Confirmation),
        true
      )
    ) {
      stateVars.Notify = await ReactSystemFunctions.notify(
        this,
        ReactSystemFunctions.translateCustomActions(
          this.ml,
          "99cd2451_4a30_9420_9b55_4da898059ee8_notify",
          this.defaultML,
          "Teklif Seçimi yapıldı"
        ),
        ReactSystemFunctions.convertToTypeByName("success", "string"),
        ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
        0,
        ReactSystemFunctions.convertToTypeByName("", "string"),
        ReactSystemFunctions.convertToTypeByName("", "string"),
        0
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemePlanSpotTekliflerComponent_971265_onClick10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemePlanSpotTekliflerComponent_971265_onClick10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [53291, 869050] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemePlanSpotTekliflerPageInit();
    }
    if (diId == 53291) {
      isErrorOccurred =
        await this.YuklemePlanSpotTekliflerComponent_329984_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
